import request from '@/utils/request'
import { getToken } from '../utils/auth'
// sip账号查询
export function querysip () {
  return request({
    url: '/querysip',
    method: 'post',
    params: { token: getToken() }
  })
}
// 新建sip账号
export function addsip (data) {
  return request({
    url: '/addsip',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新sip账号
export function updatesip (data) {
  return request({
    url: '/updatesip',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除sip账号
export function deletesip (data) {
  return request({
    url: '/deletesip',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 绑定sip账号
export function oemuserbindsip (data) {
  return request({
    url: '/oemuserbindsip',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sipPhone.js